import { type FC } from 'react';
import { useFragment, graphql } from 'react-relay';

import { GetHelpZendeskSellerPopularArticles } from './GetHelpZendeskSellerPopularArticles.tsx';
import { GetHelpZendeskBrowseByTopic } from './GetHelpZendeskBrowseByTopic.tsx';
import { GetHelpZendeskSellerOrderTile } from './GetHelpZendeskSellerOrderTile.tsx';

import { type GetHelpZendeskSellerOrder_viewer$key } from './__generated__/GetHelpZendeskSellerOrder_viewer.graphql.ts';

import dibsCss from 'dibs-css';

const viewerFragment = graphql`
    fragment GetHelpZendeskSellerOrder_viewer on Viewer {
        ...GetHelpZendeskSellerOrderTile_viewer
        ...GetHelpZendeskBrowseByTopic_viewer
        ...GetHelpZendeskSellerPopularArticles_viewer
    }
`;

const GetHelpZendeskSellerOrder: FC<{
    viewer: GetHelpZendeskSellerOrder_viewer$key;
}> = ({ viewer: viewerRef }) => {
    const viewer = useFragment(viewerFragment, viewerRef);

    return (
        <>
            <GetHelpZendeskSellerOrderTile viewer={viewer} />
            <div className={dibsCss.mtMedium}>
                <GetHelpZendeskSellerPopularArticles viewer={viewer} />
            </div>
            <div className={dibsCss.mtMedium}>
                <GetHelpZendeskBrowseByTopic viewer={viewer} />
            </div>
        </>
    );
};

export { GetHelpZendeskSellerOrder };
